import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['samplesContainer', 'sampleTemplate'];

  addSample(event) {
    event.preventDefault();
    
    const newSample = this.createNewSample();
    this.updateSampleIndexes(newSample);
    this.samplesContainerTarget.appendChild(newSample);
  }

  removeSample(event) {
    event.preventDefault();
    
    const sampleField = event.target.closest('.sample-field');
    if (sampleField) {
      this.markSampleForDeletion(sampleField);
      this.hideSampleField(sampleField);
    }
  }

  createNewSample() {
    const template = this.sampleTemplateTarget;
    return template.content.cloneNode(true);
  }

  updateSampleIndexes(newSample) {
    const nextIndex = this.getNextSampleIndex();
    
    this.updateInputNamesAndIds(newSample, nextIndex);
    this.updateLabelAttributes(newSample, nextIndex);
  }

  getNextSampleIndex() {
    const existingSamples = this.samplesContainerTarget.querySelectorAll('.sample-field');
    return existingSamples.length;
  }

  updateInputNamesAndIds(newSample, index) {
    const inputs = newSample.querySelectorAll('input, select');
    
    inputs.forEach((input) => {
      if (input.name) {
        input.name = input.name.replace('[new_sample]', `[${index}]`);
      }
      if (input.id) {
        input.id = input.id.replace('new_sample', index);
      }
    });
  }

  updateLabelAttributes(newSample, index) {
    const labels = newSample.querySelectorAll('label');
    
    labels.forEach((label) => {
      const forAttribute = label.getAttribute('for');
      if (forAttribute) {
        label.setAttribute('for', forAttribute.replace('new_sample', index));
      }
    });
  }

  markSampleForDeletion(sampleField) {
    const destroyField = sampleField.querySelector('input[name*="[_destroy]"]');
    if (destroyField) {
      destroyField.value = '1';
    }
  }

  hideSampleField(sampleField) {
    sampleField.style.display = 'none';
  }
}
